import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { formatDateTime, getMenuTypeName, getReturnOrderStatus, numberWithComma } from 'helpers/format'
import { selectCurrentUser } from 'Store/user/selector'
import styled from 'styled-components'
import theme from 'Components/common/Theme'
import { menuReturnPaymentTypes, ReturnStatus } from 'helpers/constanst'
import { TableListPage } from 'Components/common/Table'
import { Pagination } from 'Components/Pagination'
import { cloneDeep } from 'lodash'
import { StatusTag } from 'Components/utilities'
import { deleteReturnAPI, returnListAPI } from 'Store/return-order/api'
import { selectReturnActionEvent, selectReturnList, selectReturnListEvent } from 'Store/return-order/selector'
import ReturnDetail from '../detail'
import { DeleteReturnReq, ReturnData, ReturnListReq } from 'Store/return-order/types'
import { DetailDrawer } from 'Components/common/MainLayout'
import { ActionButton } from 'Components/button'
import { DeleteOutlined } from '@ant-design/icons'
import { ConfirmDailog, EventModal } from 'Components/modal'
import { clearEventAction } from 'Store/return-order/actions'
import { Empty } from 'antd'

type Props = ReduxProps & {
  isShow: boolean
  onClose: () => void
  orderNo?: string
  onSuccess?: () => void
}

const ReturnOrderDrawer: React.FunctionComponent<Props> = props => {
  const { currentUser, listEvent, list, onSuccess = () => {}, orderNo, isShow, onClose, event } = props

  const initFilter = {
    order_by: 'created_at',
    sort: 'asc',
  }

  const dispatch = useDispatch()
  const [detailDrawer, setDetailDrawer] = useState(false)
  const [filter, setFilter] = useState(cloneDeep(initFilter))
  const [selectedID, setSelectedID] = useState(0)
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false)
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 20,
  })

  const meta = list?.meta
  const datas = list?.data

  useEffect(() => {
    if (currentUser?.accessToken && orderNo && isShow) {
      onGetList()
    }
  }, [pagination, orderNo, isShow])

  const onGetList = (): void => {
    const req: ReturnListReq = {
      keyword: orderNo,
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      start_date: '',
      end_date: '',
      sort: filter.sort || 'desc',
      order_by: filter.order_by || 'created_at',
      status: '',
    }

    dispatch(returnListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const onDelete = (id: number): void => {
    const req: DeleteReturnReq = {
      id,
    }
    dispatch(deleteReturnAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  useEffect(() => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }, [filter?.order_by, filter?.sort])

  const onSort = (order_by: string, sort: string) => {
    setFilter({
      ...filter,
      sort,
      order_by,
    })
  }

  const renderStatus = (status: string) => {
    const statusResult = getReturnOrderStatus(status)
    return <StatusTag text={statusResult.text} color={statusResult.color} />
  }

  const onOpenDetailDrawer = () => {
    setDetailDrawer(true)
  }

  const onClickViewDetail = (id: number) => {
    setSelectedID(id)
    onOpenDetailDrawer()
  }

  const onCloseDetailDrawer = () => {
    setDetailDrawer(false)
  }

  const onOpenConfirmDelete = () => {
    setConfirmDeleteDialog(true)
  }

  const onCloseConfirmDelete = () => {
    setConfirmDeleteDialog(false)
  }

  const onClickDelete = (id: number) => {
    setSelectedID(id)
    onOpenConfirmDelete()
  }

  const onConfirmDelete = () => {
    onDelete(selectedID)
    onCloseConfirmDelete()
  }

  const ConfirmDeleteModal = (
    <ConfirmDailog
      title={'ยืนยันการลบรายการรับคืนสินค้า'}
      isShow={confirmDeleteDialog}
      handleOk={onConfirmDelete}
      handleCancel={onCloseConfirmDelete}
    />
  )

  const renderActionButton = (text: string, record: ReturnData) => {
    if (record?.status !== ReturnStatus.DRAFT) return
    return (
      <ActionButton
        text=""
        icon={<DeleteOutlined />}
        label="ลบรายการ"
        action="deleted"
        onClick={() => onClickDelete(record.id)}
      />
    )
  }

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'no',
      key: 'no',
      render: (value: any, record: ReturnData, index: number) => {
        return index + 1 + (pagination.Page - 1) * pagination.RowPerPage
      },
      width: '60px',
    },
    {
      title: 'เลขที่สั่งซื้อ',
      dataIndex: 'order_no',
      key: 'order_no',
      width: '180px',
      // eslint-disable-next-line react/display-name
      render: (val: string, record: ReturnData) => (
        <LinkNo onClick={() => onClickViewDetail(record.id)}>{val}</LinkNo>
      ),
      //sorter: true,
    },
    // {
    //   title: 'ลูกค้า',
    //   dataIndex: 'customer_fullname',
    //   key: 'customer_fullname',
    //   sorter: true,
    // },
    {
      title: 'ยอดเงินคืนสุทธิ',
      dataIndex: 'total_amount',
      key: 'total_amount',
      //sorter: true,
      align: 'right',
      width: '150px',
      // eslint-disable-next-line react/display-name
      render: (val: number) => {
        return <RedText>{numberWithComma(val, true)}</RedText>
      },
    },
    {
      title: '',
      dataIndex: '',
      key: '',
      width: '20px',
    },
    // {
    //   title: 'ช่องทางการขาย',
    //   dataIndex: 'channel',
    //   key: 'channel',
    //   sorter: true,
    //   render: (channel: string) => getMenuTypeName(menuReturnChannel, channel || ''),
    // },
    {
      title: 'วันที่รับคืนสินค้า',
      dataIndex: 'created_at',
      key: 'created_at',
      //sorter: true,
      render: (val: string) => formatDateTime(val || ''),
    },
    {
      title: 'ช่องทางการคืนเงิน',
      dataIndex: 'return_type',
      key: 'return_type',
      //sorter: true,
      render: (return_type: string) => getMenuTypeName(menuReturnPaymentTypes, return_type || ''),
    },
    {
      title: 'สถานะการคืนเงิน',
      dataIndex: 'status',
      key: 'status',
      render: renderStatus,
      //sorter: true,
    },
    {
      title: 'รับคืนโดย',
      dataIndex: 'officer',
      key: 'officer',
      //sorter: true,
    },
    {
      width: '80px',
      title: '',
      key: 'action',
      align: 'center',
      render: renderActionButton,
    },
  ]

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  const ReturnOrderDetailDrawer = (
    <ReturnDetail
      id={selectedID}
      visible={detailDrawer}
      onCloseDrawer={onCloseDetailDrawer}
      onSuccess={() => {
        onGetList()
      }}
      onPaymentSuccess={onSuccess}
    />
  )

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onDeleteSuccess = (): void => {
    clearEvent()
    onGetList()
    onSuccess()
  }

  const LoadingModal = (
    <EventModal event={[event]} enable={true} successCalback={onDeleteSuccess} errorCalback={clearEvent} />
  )

  return (
    <DetailDrawer
      title={`ประวัติการรับคืนสินค้า`}
      width={'80%'}
      onCloseDrawer={onClose}
      visible={isShow}
      footer={null}
      maskClosable={true}
    >
      {ReturnOrderDetailDrawer}
      {ConfirmDeleteModal}
      {LoadingModal}
      {datas.length <= 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      ) : (
        <TableListPage
          columns={columns}
          datas={datas || []}
          isLoading={listEvent.IsLoading}
          paginationContent={null}
          size="middle"
          offsetHeader={-25}
          onSort={(field: string, order: string) => {
            onSort(field, order)
          }}
          scrollX={800}
        />
      )}
    </DetailDrawer>
  )
}

const LinkNo = styled.div`
  cursor: pointer;
  text-decoration: underline;
  font-family: ${theme.fontFamily.bold};
  color: ${theme.colors.primary};
`

const RedText = styled.div`
  color: ${theme.colors.error};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    list: selectReturnList(state),
    listEvent: selectReturnListEvent(state),
    event: selectReturnActionEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ReturnOrderDrawer)
